import axios from "axios";
import { useEffect, useRef, useState } from "react";
import { IoIosArrowDown as ArrowDown } from "react-icons/io";
import { NotificationManager } from "react-notifications";
import Select from "react-select";
import dollor from "../../../assets/icons/dollar.svg";
import percentage from "../../../assets/icons/percentage.svg";
import FilterFieldHeader from "../../../components/FilterComponents/FilterFieldHeader";
import OptionalOption from "../../../components/FilterComponents/OptionalOption";
import InputWithIcon from "../../../components/InputWithIcon";
import useAuth from "../../../hooks/useAuth";
import { BASE_URL } from "../../../utils/Element";
import { StatusOptions } from "../../../utils/options";
import { handleDropdownClose } from "../../../utils/utils";

const ExclusiveFilterData = ({ isSidebarOpen, filterData, onSetFilterData, from }) => {
  const [config] = useAuth();
  const [loading, setLoading] = useState(false);
  const [contactData, setContactData] = useState([]);
  const [brokerOptions, setBrokerOptions] = useState([]);
  const selectRef = useRef(null);
  const dropdownRef = useRef(null);
  const [isOpen, setIsOpen] = useState(false);

  const handleFilterChange = (value, name) => {
    onSetFilterData({ ...filterData, [name]: value });
  };

  const fetchSuggestions = (inputValue) => {
    axios
      .get(`${BASE_URL}/get-datalisting?list=contacts&search=${inputValue}`, config)
      .then((res) => {
        const data = res.data.data.contact_list;
        const options = data.map((contact) => ({ value: contact.id, label: `${contact.first_name} ${contact.last_name}` }));
        setContactData(options);
      })
      .catch((err) => {
        if (err.response?.data?.message && err.response?.data?.message !== "Too Many Attempts.") {
          NotificationManager.error(err.response?.data?.message);
        }
      });
  };

  const fetchUsers = () => {
    setLoading(true);
    axios
      .get(`${BASE_URL}/get-datalisting?list=users`, config)
      .then((res) => {
        const data = res?.data?.data;
        const options = data?.map((el) => ({ value: el?.id, label: `${el?.first_name} ${el?.last_name}`, role: el?.role_id }));
        setBrokerOptions(options?.filter((el) => el.role === 3));
      })
      .catch((err) => {
        if (err.response?.data?.message && err.response?.data?.message !== "Too Many Attempts.") {
          NotificationManager.error(err.response?.data?.message);
        }
      })
      .finally(() => setLoading(false));
  };

  useEffect(() => {
    if (isSidebarOpen) {
      fetchUsers();
    }
  }, [isSidebarOpen]);

   useEffect(() => {
     const handleClose = () => {
       setIsOpen(false);
     };
     handleDropdownClose(dropdownRef, handleClose);
   }, []);

  if (from === "exclusivearchieve") {
    return (
      <div>
        <p className="head-4 dark-H">Date Range</p>

        <OptionalOption
          activeTab="date"
          onSetLastDate={(value) => onSetFilterData({ ...filterData, count: value })}
          date={filterData?.count}
          onSetDateRange1={(value) =>
            onSetFilterData({ ...filterData, start_count: value })
          }
          date2={filterData?.start_count}
          onSetDateRange2={(value) =>
            onSetFilterData({ ...filterData, end_count: value })
          }
          date3={filterData?.end_count}
          onClear={() => {
            onSetFilterData({
              ...filterData,
              count: "",
              start_count: "",
              end_count: "",
            });
          }}
        />
      </div>
    );
  }




  return (
    <div>

      <div>
        <p className="head-4 dark-H">Property Name</p>

        <div className="search-box mt-2">
          <input
            type="text"
            className="body-S"
            placeholder="write here"
            style={{ width: "100%" }}
            value={filterData?.property_name}
            onChange={(e) => {
              handleFilterChange(e.target.value, "property_name");
            }}
          />
        </div>
      </div>

      <hr className="my-6" style={{ borderColor: "#6F6F6F" }} />

      <div>
        <p className="head-4 dark-H capitalize">Exclusive Date</p>

        <OptionalOption
          activeTab="date"
          onSetLastDate={(value) => handleFilterChange(value, "created_at")}
          date={filterData?.created_at}
          onSetDateRange1={(value) => {
            handleFilterChange(value, "created_start_date");
          }}
          date2={filterData?.created_start_date}
          onSetDateRange2={(value) => handleFilterChange(value, "created_end_date")}
          date3={filterData?.created_end_date}
          onClear={() => {
            onSetFilterData({ ...filterData, created_at: "", created_start_date: "", created_end_date: "" });
          }}
        />
      </div>

      <hr className="my-6" style={{ borderColor: "#6F6F6F" }} />

      <div>
        <FilterFieldHeader
          title={"Asking Cap Rate"}
          data={filterData?.min_asking_cap_rate}
          type="to"
          symbol={"  to  "}
          data2={filterData?.max_asking_cap_rate}
          handleCross={() => {
            onSetFilterData({ ...filterData, min_asking_cap_rate: "", max_asking_cap_rate: "" });
          }}
        />

        <div className="flex flex-row mt-2">
          <div className="w-[50%]">
            <InputWithIcon icon={percentage} type="number" min={0} placeholder="min rate" value={filterData?.min_asking_cap_rate} onChange={(e) => handleFilterChange(e.target.value, "min_asking_cap_rate")} />
          </div>
          <div className="w-[50%]">
            <InputWithIcon icon={percentage} type="number" min={0} placeholder="max rate" value={filterData?.max_asking_cap_rate} onChange={(e) => handleFilterChange(e.target.value, "max_asking_cap_rate")} />
          </div>
        </div>
      </div>

      <hr className="my-6" style={{ borderColor: "#6F6F6F" }} />

      <div>
        <FilterFieldHeader
          title={"Asking Price"}
          data={filterData?.min_asking_price}
          type="to"
          symbol={"  to  "}
          data2={filterData?.max_asking_price}
          handleCross={() => {
            onSetFilterData({ ...filterData, min_asking_price: "", max_asking_price: "" });
          }}
        />

        <div className="flex flex-row mt-2">
          <div className="w-[50%]">
            <InputWithIcon icon={dollor} type="number" min={0} placeholder="min rate" value={filterData?.min_asking_price} onChange={(e) => handleFilterChange(e.target.value, "min_asking_price")} />
          </div>
          <div className="w-[50%]">
            <InputWithIcon icon={dollor} type="number" min={0} placeholder="max rate" value={filterData?.max_asking_price} onChange={(e) => handleFilterChange(e.target.value, "max_asking_price")} />
          </div>
        </div>
      </div>

      <hr className="my-6" style={{ borderColor: "#6F6F6F" }} />

      <div>
        <p className="head-4 dark-H">NOI</p>

        <div className="mt-2">
          <InputWithIcon
            icon={dollor}
            type="number"
            min={0}
            placeholder="write here"
            value={filterData?.noi}
            onChange={(e) => {
              handleFilterChange(e.target.value, "noi");
            }}
          />
        </div>
      </div>

      <hr className="my-6" style={{ borderColor: "#6F6F6F" }} />

      <div className="mt-4">
        <label className="dark-H head-4 mb-2">
          Listing Broker <span className="red-D">*</span>
        </label>
        <Select
          ref={selectRef}
          className="body-N"
          options={brokerOptions}
          placeholder="Select"
          value={brokerOptions.find((option) => option?.value === filterData?.listing_broker) || null}
          onChange={(option) => {
            handleFilterChange(option?.value, "listing_broker");
          }}
        />
      </div>


      <hr className="my-6" style={{ borderColor: "#6F6F6F" }} />

      <div className="mt-4">
        <p className="head-4 dark-H">Status</p>

        <div ref={dropdownRef} className="custom-dropdown mt-2">
          <div
            role="button"
            className="select-header-input capitalize light-bg-L body-N dark-M flex justify-between items-center"
            onClick={() => {
              setIsOpen(!isOpen);
            }}
          >
            {filterData.status === ""
              ? "Select"
              : (StatusOptions.find((el) => el.value === filterData.status)?.label || "Select")
            } <ArrowDown />
          </div>
          {isOpen && (
            <div className="dropdown-list-container light-bg-L dark-M body-N shadow rounded-box" style={{ width: "100%" }}>
              <ul className="dropdown-list">
                {StatusOptions.map((el, i) => (
                  <li
                    key={i}
                    role="button"
                    onClick={() => {
                      handleFilterChange(el.value, "status");
                      setIsOpen(false);
                    }}
                    className={`${filterData.status === el.value ? "active" : ""}`}
                  >
                    {el.label}
                  </li>
                ))}
              </ul>
            </div>
          )}
        </div>

        <hr className="my-6" style={{ borderColor: "#6F6F6F" }} />
      </div>


    </div>
  );
};

export default ExclusiveFilterData;
